@if (isLinkAvailable) {
  <a
    class="link-to-sim_link"
    [href]="linkUrl"
    target="_blank"
    (click)="navigateToSimulator($event)">
    <svg class="link-to-sim_icon"
      tooltipL10n="components.link-to-simulator.link_tooltip">
      <use xlink:href="#go-sim-logo"></use>
    </svg>
  </a>
}
